<template>
  <header
    class="sticky top-12 z-40 border-b border-gray-200 bg-white shadow-sm"
    role="banner"
  >
  <div class="flex flex-col gap-5 px-5 py-5 sm:px-6 lg:flex-row lg:items-start lg:justify-between lg:px-10">
      <div class="flex items-center justify-between gap-4">
        <div class="flex flex-col gap-1">
          <h1 class="flex flex-col text-2xl font-semibold leading-tight text-gray-900 sm:text-[1.75rem]">
            <span class="text-base font-medium uppercase tracking-wide text-gray-400">Bonjour</span>
            <span class="text-2xl font-semibold text-gray-900 sm:text-[1.75rem]">{{ userGreeting }}</span>
          </h1>
        </div>
      </div>
      <div class="flex flex-col gap-4 w-full lg:flex-row lg:items-start lg:justify-end lg:gap-8">
        <div class="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-end lg:gap-3">
          <span class="text-sm font-semibold uppercase tracking-wide text-gray-500">Choisir une période</span>
          <dashboard-date-filters
            :quick-ranges="quickRanges"
            :active-range-id="activeRangeId"
            :date-range="dateRange"
            :max-date="maxDate"
            @select-range="$emit('select-range', $event)"
            @show-full="$emit('show-full')"
            @update:date-range="$emit('update:date-range', $event)"
          />
        </div>
        <slot name="right" />
      </div>
    </div>
  </header>
</template>

<script>
import DashboardDateFilters from '@/components/dashboard/DashboardDateFilters.vue'

export default {
  name: 'DashboardHeader',
  components: {
    DashboardDateFilters
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    userStatusLabel: {
      type: String,
      default: ''
    },
    userGreeting: {
      type: String,
      default: ''
    },
    quickRanges: {
      type: Array,
      default: () => []
    },
    activeRangeId: {
      type: String,
      default: null
    },
    dateRange: {
      type: [Array, String],
      default: () => []
    },
    maxDate: {
      type: String,
      required: true
    }
  },
  emits: ['select-range', 'show-full', 'update:date-range']
}
</script>
